import ContainerBlockGenericType from "../ContainersBlocks/ContainerBlockGenericType";

function LC
    ({ id, isConnectable, type, selected }) {
    return (
        <ContainerBlockGenericType
            id={id}
            isConnectable={isConnectable}
            type={type}
            selected={selected}
            flagNumber={42}
            labelBlock={'LC'}
            userConfiguration={true}
        />
    );
}
export default LC